"use client";

import { motion } from "framer-motion";

import { cn } from "@/utils/cn";

// Converts the FFT data (normalized to 0-1) into a percentage for the bar height.
const mapToBarHeight = (v: number) => 4 + v * 140;

export function WaveformBars({
  data,
  active,
  barWidth,
}: {
  data: number[];
  active: boolean;
  barWidth: string;
}) {
  return (
    <>
      {data.map((value, i) => (
        <motion.div
          key={i}
          className={cn(
            barWidth,
            "rounded-full",
            active ? "bg-gray-800" : "bg-gray-300"
          )}
          animate={{ height: `${mapToBarHeight(value)}%` }}
          transition={{
            type: "tween",
            duration: active ? 0.06 : 0.05,
            ease: "easeOut",
          }}
        />
      ))}
    </>
  );
}
